import React from 'react';
// import { Link } from 'react-router-dom';
// import useFetchData from '../../hooks/useFetch/useFetchData';
// import Loading from '../../utils/Loader/Loading';
import MessageContainer from './MessageContainer';
import Link from 'next/link';

const MessageFromManagement = ({ messages }: any) => {
    // const { data: messageManagementRes, isLoading: isLoadingMessage, isError: isErrorMessage } = useFetchData('messageManagement', 'messageManagement/active');
    // const { data: teamRes, isLoading: isLoadingTeam, isError: isErrorTeam } = useFetchData('team-members', 'team-members');

    // const { data: blogRes, isLoading: isLoadingBlogs, isError: isErrorBlogs } = useFetchData(
    //     'blogs',
    //     `blogs/get-blogs/active`
    // );

    // const messages = messageManagementRes?.data;
    // const teamMembers = teamRes?.data;
    // const blogArray = blogRes?.data;

    // console.log("Message =>", messages);
    // console.log("teamMembers =>", teamMembers);
    // console.log("BlogArray =>", blogArray);

    // if (isErrorMessage) return <div className="text-center"><Loading /></div>;

    // if (isErrorMessage) // console.log("isErrorMessage", isErrorMessage);

    return (
        <>
            <div
                className="breadcrumb-section"
                style={{
                    backgroundImage:
                        "linear-gradient(270deg, rgba(0, 0, 0, .3), rgba(0, 0, 0, 0.3) 101.02%), url(../../../../assets/img/innerpage/inner-banner-bg.png)"
                }}
            >
                {/* <div className="container">
                    <div className="row">
                        <div className="col-lg-12 d-flex justify-content-center">
                            <div className="banner-content">
                                <h1>About Us</h1>
                                <ul className="breadcrumb-list">
                                    <li>
                                        <Link href={"/"}>Home</Link>
                                    </li>
                                    <li>
                                        <Link href={"/about"}>About Us</Link>
                                    </li>
                                    <li>Message From Management</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* breadcrumb */}
                <div
                    className="site-breadcrumb"
                    style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
                >
                    <div className="container">
                        <h2 className="breadcrumb-title">About Us</h2>
                        <ul className="breadcrumb-menu">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/about">About</a>
                            </li>
                            <li className="active">Message From Management</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="home2-about-section">
                <MessageContainer messages={messages} />
            </div>
        </>
    );
};


export default MessageFromManagement;